module.exports = __webpack_public_path__ + "img/p13.c9fd82b9.gif";